module.exports = __webpack_public_path__ + "img/category-experiment.715f10eb.svg";